import { sendGTMEvent } from '@next/third-parties/google'

function createThrottledSendGoogleGTMEvent(delay = 1000) {
  let lastExecutionTime = 0

  return function (data: object) {
    const currentTime = Date.now()
    if (currentTime - lastExecutionTime >= delay) {
      sendGTMEvent(data)
      lastExecutionTime = currentTime
    }
  }
}

// Create a single throttled function instance
const throttledSendGoogleGTMEvent = createThrottledSendGoogleGTMEvent()

export function sendGoogleGTMEvent(data: object) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    throttledSendGoogleGTMEvent(data)
  }
}
